import React, {Component} from "react";
import SelectNormal from "../select/SelectNormal";
import RCPagination from "rc-pagination";
import localeInfo from './../pagination/PaginationLocalInfo';

import '../../../assets/sass/components/pagination/pagination.scss';
import $ from "jquery";
import * as PropTypes from "prop-types";

class Pagination extends Component {
    constructor(props) {
        super(props);

        const {currentPage, pageSize} = this.props;

        this.state = {
            currentPage: currentPage,
            pageSize: pageSize,
        };
    }

    render = () => {
        var {showRowsText, pageSizeOptions, defaultOption, currentPage, pageSize, totalSize, defaultCurrentPage} = this.props;
        // const defaultPageSize = defaultOption ? defaultOption.value : null;

        const defaultPageSizeOptions = [10, 20, 30, 50].map(item => {
            return {value: item, label: item}
        });
        var pageSizeOptions = pageSizeOptions ? pageSizeOptions : defaultPageSizeOptions;
        var defaultOption = defaultOption ? defaultOption : defaultPageSizeOptions[0];

        return (
            <div className="pagination-container">
                <div className="show-rows"> {showRowsText} </div>
                <SelectNormal
                    color="flat"
                    type="sm"
                    menuPlacement="top"
                    options={pageSizeOptions}
                    defaultValue={defaultOption}
                    onChange={this.handleSizePerPageChange}
                />
                <RCPagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={totalSize}
                    defaultCurrent={defaultCurrentPage}
                    defaultPageSize={defaultOption.value}
                    locale={this.localeInfo()}
                    onChange={this.handlePageChange}
                    showQuickJumper={{goButton: this.renderGoButton()}}
                />
            </div>
        );
    };


    renderGoButton = () => {
        const {goText} = this.props;

        return (
            <button className="go-button"> {goText} </button>
        );
    };

    handleSizePerPageChange = (event) => {
        const {onSizePerPageChange, onChange} = this.props;

        this.setState({
            ...this.state,
            pageSize: event.value,
        }, () => {
            if (typeof onChange === 'function')
                onChange(this.state);
        });

        if (typeof onSizePerPageChange === 'function')
            onSizePerPageChange(event.value);
    };

    handlePageChange = (value) => {
        const {onPageChange, onChange} = this.props;

        this.setState({
            ...this.state,
            currentPage: value,
        }, () => {
            if (typeof onChange === 'function')
                onChange(this.state);
        });

        if (typeof onPageChange === 'function')
            onPageChange(value);
    };

    handleUpdatePageInput = (current) => {
        $('.rc-pagination-options-quick-jumper input').val(current);
    };

    componentDidUpdate = (prevProps, prevState, snapshot) => {
        const {currentPage} = this.props;
        this.handleUpdatePageInput(currentPage);
    };

    localeInfo = () => localeInfo;

    static propTypes = {
        // The options of page size.
        pageSizeOptions: PropTypes.arrayOf(PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.any.isRequired,
        })).isRequired,

        // The default option of page size.
        defaultOption: PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.any.isRequired,
        }).isRequired,

        // The current page.
        currentPage: PropTypes.number.isRequired,
        // The default page
        defaultCurrentPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        // The size of each page.
        pageSize: PropTypes.number.isRequired,
        // The total size of all pages.
        totalSize: PropTypes.number.isRequired,

        // The text witch appears before the page size select.
        showRowsText: PropTypes.string,
        // The text witch appears after go to page box.
        goText: PropTypes.string,

        // The handler witch fire when changing size of the pages.
        onSizePerPageChange: PropTypes.func,

        // The handler witch fire when changing current page.
        onPageChange: PropTypes.func,
    };

    static defaultProps = {
        goText: 'Go',
        showRowsText: 'Show Rows',
        defaultCurrentPage: 1,
    };
}

export default Pagination;
